import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpRightMdLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "M 9,6.25 C 8.5857904,6.25 8.25,6.5857904 8.25,7 8.25,7.4142096 8.5857904,7.75 9,7.75 h 6.189453 L 6.46875,16.46875 c -0.2928897,0.2929 -0.2928897,0.7696 0,1.0625 0.2928897,0.2929 0.7696103,0.2929 1.0625,0 L 16.25,8.8105469 V 15 c 0,0.4142 0.3358,0.75 0.75,0.75 0.4142,0 0.75,-0.3358 0.75,-0.75 V 7 C 17.75,6.5857904 17.4142,6.25 17,6.25 Z"
	})]
});
export default SvgArrowUpRightMdLine;
